import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'

Vue.use(Vuex)

// 应用初始状态
const state = {
    count: 10,
    passId : 1,
    changspanshow:1,
    anwser:"",
    question:""
}

// 定义所需的 mutations
const mutations = {
    INCREMENT(state) {
        state.count++
    },
    DECREMENT(state) {
        state.count--
    },
    SETPASSID(state){
        state.passId = state
    },
    ANSWER(state,val)  {
        state.anwser = val
    },
    QUSETION_STATE(state,val){
        state.question = val
    }
}

// 创建 store 实例
export default new Vuex.Store({
    actions,
    getters,
    state,
    mutations
})


// WEBPACK FOOTER //
// ./src/vuex/store.js